import { cn } from "@/lib/utils";
import { motion } from "framer-motion";
import Image from "next/image";
import { DetailedHTMLProps, HTMLAttributes, useMemo } from "react";

// 처음 몇 개의 이미지를 eager 로딩할지 결정하는 상수
const EAGER_LOAD_COUNT = 3;

export const Tilerail = ({
    style,
    height,
    items,
    direction,
    duration,
    edge,
    gap,
    className,
    ...props
}: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
    items: string[];
    height: number;
    edge: number;
    duration: number;
    direction: 1 | -1;
    gap: number;
}) => {
    const validItems = useMemo(() => items, [items]);
    const groupHeight = validItems.length * (edge + gap);

    // 무한 스크롤을 위한 타일 그룹 렌더링 함수
    const renderTileGroup = () => (
        <motion.div
            className="flex w-full flex-col"
            initial={{ y: direction === 1 ? -groupHeight : 0 }}
            animate={{ y: direction === 1 ? 0 : -groupHeight }}
            transition={{
                duration,
                ease: "linear",
                repeat: Infinity
            }}
        >
            {validItems.map((imgurl, index) => (
                <div
                    key={index}
                    className="relative flex aspect-square select-none
                        items-center justify-center overflow-hidden
                        rounded-[20px] bg-white lg:rounded-xl"
                    style={{
                        width: edge,
                        height: edge,
                        marginBottom: gap
                    }}
                >
                    <Image
                        alt=""
                        src={imgurl}
                        fill={true}
                        className="object-cover"
                        sizes="(max-width: 768px) 56px, (max-width: 1024px) 64px, 80px"
                        loading={index < EAGER_LOAD_COUNT ? "eager" : "lazy"}
                    />
                </div>
            ))}
        </motion.div>
    );

    return (
        <div
            className={cn(
                "relative flex h-full flex-col overflow-hidden",
                className
            )}
            style={{ ...style, width: edge }}
            {...props}
        >
            {renderTileGroup()}
            {renderTileGroup()}
        </div>
    );
};
